import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs/internal/Subject';
import { throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';

import { Profile } from '@df/interfaces';
import { MAIN_DOMAIN } from '@app/app.constants';

import { AccountService } from '@teacher/services/account.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-main-profile-settings',
    templateUrl: './main-profile-settings.component.html',
    styleUrls: ['./main-profile-settings.component.scss']
})
export class MainProfileSettingsComponent implements OnInit, OnDestroy {
    profile: Profile;
    form: FormGroup;
    main_domain: string = MAIN_DOMAIN;
    photoName: any;
    fileExtension: any;

    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(
        private accountService: AccountService,
        private _snackBar: MatSnackBar,
        private fb: FormBuilder,
        private route: ActivatedRoute
    ) {}

    get hasProfilePhoto(): boolean {
        return this.profile.avatar !== '';
    }

    ngOnInit(): void {
        this.route.data.subscribe(data => {
            this.profile = data['profile'].data;
        });
        this.form = this.fb.group({
            firstName: [this.profile.user.first_name, [Validators.minLength(2), Validators.maxLength(35)]],
            lastName: [this.profile.user.last_name, [Validators.minLength(2), Validators.maxLength(30)]],
            middleName: [this.profile.middle_name, [Validators.minLength(2), Validators.maxLength(30)]],
            avatar: ['', []]
        });
    }

    messageHandler(msg: string, duration: number = 5000) {
        this._snackBar.open(msg, 'Закрыть', {
            duration: duration,
            verticalPosition: 'top'
        });
    }

    onSubmit(): void {
        if (this.form.valid) {
            this.profile.user.first_name = this.form.value.firstName;
            this.profile.user.last_name = this.form.value.lastName;
            this.profile.middle_name = this.form.value.middleName;
        }
    }

    updateProfilePhoto($event) {
        const files = $event.target.files || $event.srcElement.files;
        const file: File = files[0];
        if (file) {
            const formData = new FormData();
            const reader = new FileReader();
            reader.readAsDataURL(files[0]);
            reader.onload = eventReader => {
                // @ts-ignore-start
                this.profile.avatar = eventReader.target.result;
                // @ts-ignore-end
            };

            formData.append('avatar', file, file.name);
            formData.append('profile_id', String(this.profile.id));

            const allowedExtensions: Array<string> = ['jpg', 'jpeg', 'png', 'gif', 'BMP', 'SVG'];
            this.fileExtension = file.name.split('.').pop();

            if (allowedExtensions.indexOf(this.fileExtension.toLowerCase()) > -1) {
                this.accountService.patchAvatarProfile(formData).subscribe(
                    () => {
                        const successMsg = 'Информация обновлена';
                        this.messageHandler(successMsg);
                        this.accountService.getProfileData().subscribe(resp => {
                            this.accountService.profile.next(resp.data);
                        });
                    },
                    (error: HttpErrorResponse) => {
                        console.error(error);
                        const errorMsg = 'Произошла ошибка';
                        this.messageHandler(errorMsg);
                        return throwError(error);
                    }
                );
            } else {
                const errorMsg = 'Файл должен быть формата jpg, jpeg, png, gif, bmp, svg';
                this.messageHandler(errorMsg);
            }
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
    }
}
